import { render, staticRenderFns } from "./ClientUsersTable.vue?vue&type=template&id=6b5092be&scoped=true"
import script from "./ClientUsersTable.vue?vue&type=script&lang=js"
export * from "./ClientUsersTable.vue?vue&type=script&lang=js"
import style0 from "./ClientUsersTable.vue?vue&type=style&index=0&id=6b5092be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5092be",
  null
  
)

export default component.exports